import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FilterBar from "../components/FilterBarClients.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import ClientsStats from "./ClientsStats.js";
 const token = localStorage.getItem('token');
const ClientsList = () =>{
    const[clients, setClients] =useState([]);
    const[filteredClients, setFilteredClients] = useState([]);
    const[serviceTypeFilter, setServiceTypeFilter] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();
    useEffect(()=> {
        fetchClients();
    },[]);
    const fetchClients = async()=>{
        try{
            const res = await axios.get("/client", {
                headers: { Authorization: `Bearer ${token}` },
            });
            const nonDeleted = res.data.filter((p)=>p.deletedAt === null);
            setClients(nonDeleted);
        }catch (error){
            console.error("Erreur lors du chargement des clients")
        }};
    const filterClients =useCallback(()=>{
        let filtered =[...clients];
        if (serviceTypeFilter !== "all"){
            filtered = clients.filter((c) =>c.projects?.some((p) => p.serviceType === serviceTypeFilter));}
        if (searchTerm.trim() !== "") {
      filtered = filtered.filter((p) =>
        p.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
        setFilteredClients(filtered);
    },[clients , serviceTypeFilter, searchTerm]);
    useEffect(()=>{
        filterClients();
        },[filterClients]);
    const handleDelete =async (id)=>{
        try{await axios.delete(`/client/id/${id}`,{
            headers:{
                Authorization:
                `Bearer ${token}`,},});
            fetchClients();}
            catch(error){
                console.error("Erreur lors de la suppression", error);
            }}
    return(
    <div className="dashboard-container">
      {/* Top Bar */}
      <div className="top-bar">
        <h3>Gestion des clients</h3>
        <div>
          <button onClick={() => navigate("/admin/clients/new")} className="bout-new">
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: "8px" }} />
            Nouveau client
          </button>

          <button onClick={() => navigate("/admin/clients/trash")} className="bout-trash">
            <FontAwesomeIcon icon={faTrash} style={{ marginRight: "8px" }} />
            Corbeille
          </button>
        </div>
      </div>

      {/* Filtres */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  <FilterBar
    serviceTypeFilter={serviceTypeFilter}
    onServiceTypeChange={setServiceTypeFilter}
  />
  
  <input
    className="recherche"
    type="text"
    placeholder="Rechercher le client..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{
      padding: '3px',
      border: '1px solid #000000ff',
      borderRadius: '1px',
      flexShrink: 0,  // Prevents shrinking if content is too long
    }}
  />
</div>

      {/* Tableau */}
      <div className="liste p-4">
        <h3 className="listeh">Liste des clients</h3>
        <table className="w-full border mt-2">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">Nom</th>
              <th className="p-2 border">E-mail</th>
              <th className="p-2 border">Poste</th>
              <th className="p-2 border">Projets associés</th>
              <th className="p-2 border">Actions</th>

            </tr>
          </thead>
          <tbody>
            {filteredClients.length > 0 ? (
              filteredClients.map((client) => (
                <tr key={client.id} className="text-center">
                  <td className="p-2 border">{client.name}</td>
                  <td className="p-2 border">{client.email}</td>
                  <td className="p-2 border">{client.jobTitle}</td>
                  <td className="p-2 border">
                  <ul>
                    {client.projects.map((p) => (
                      <li key={p.id}>{p.projectName}</li>))}
                  </ul>
                  </td>
                  <td className="p-2 border space-x-2">
                    <button
                      onClick={() => navigate(`/admin/clients/${client.id}`)}
                      className="icon-button text-blue-600"
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                    <button
                      onClick={() => navigate(`/admin/clients/${client.id}/edit`)}
                      className="icon-button text-green-600"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      onClick={() => handleDelete(client.id)}
                      className="icon-button text-red-600"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="text-center p-4" colSpan={6}>
                  Aucun client trouvé.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Statistiques */}
      <ClientsStats/>
      
    </div>
    );};
export default ClientsList;
        